import { render, staticRenderFns } from "./Appoinments.vue?vue&type=template&id=90ccc914&scoped=true&"
import script from "./Appoinments.vue?vue&type=script&lang=js&"
export * from "./Appoinments.vue?vue&type=script&lang=js&"
import style0 from "./Appoinments.vue?vue&type=style&index=0&id=90ccc914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ccc914",
  null
  
)

export default component.exports